import type { Filter } from '@cubejs-client/core'
import type { GlobalCubeFilters } from '../components/CubeContext'

type MergeCubeFiltersInput = {
  serviceAreaId?: string
  serviceAreaMember?: string
  globalFilters?: GlobalCubeFilters
  cubeForGlobalFilters?: string
  localFilters?: Filter[]
  overrideFilters?: Filter[]
}

const resolveGlobalFilters = (
  globalFilters: GlobalCubeFilters | undefined,
  cubeForGlobalFilters: string | undefined,
): Filter[] => {
  if (!globalFilters) {
    return []
  }

  if (Array.isArray(globalFilters)) {
    return globalFilters
  }

  return cubeForGlobalFilters ? (globalFilters[cubeForGlobalFilters] ?? []) : []
}

// Merges filter sources in priority order: service area → global → local → override.
// globalFilters can be a flat array or a Record keyed by cube name.
export const mergeCubeFilters = ({
  serviceAreaId,
  serviceAreaMember,
  globalFilters,
  cubeForGlobalFilters,
  localFilters,
  overrideFilters,
}: MergeCubeFiltersInput): Filter[] => {
  const scopedGlobalFilters = resolveGlobalFilters(
    globalFilters,
    cubeForGlobalFilters,
  )

  const serviceAreaFilters: Filter[] =
    serviceAreaId && serviceAreaMember
      ? [
          {
            member: serviceAreaMember,
            operator: 'equals',
            values: [serviceAreaId],
          } as const,
        ]
      : []

  return [
    ...serviceAreaFilters,
    ...scopedGlobalFilters,
    ...(localFilters ?? []),
    ...(overrideFilters ?? []),
  ]
}
